/**
 * Boards of area (f) — access. OWNED BY area (f) — access (keep `id`, `href`, `path` stable: the dev navigator,
 * the smoke test and the layout audit read them). Generated by the foundation on 2026-10-15.
 */
import { lazy } from "react";
import type { BoardDef } from "@/boards/types";

export const accessBoards: BoardDef[] = [
  {
    id: "Admin-Parametres-Equipe",
    ref: "147d",
    title: "Cabinet — Paramètres · Équipe et rôles",
    area: "access",
    path: "/parametres/equipe",
    href: "/parametres/equipe",
    permission: ["team", "read"],
    persona: "admin",
    kind: "page",
    nav: "parametres",
    space: null,
    note: "Même route qu'AG-Equipe (fenêtre « Créer un accès »).",
    component: lazy(() => import("./boards/Admin-Parametres-Equipe")),
  },
  {
    id: "AG-Connexion",
    ref: "AG1",
    title: "Connexion agent / lecteur",
    area: "access",
    path: "/connexion/premiere-connexion",
    href: "/connexion/premiere-connexion",
    permission: null,
    persona: null,
    kind: "auth",
    nav: null,
    space: null,
    note: "Première connexion d'un compte créé : mot de passe défini avec le code reçu par e-mail.",
    component: lazy(() => import("./boards/AG-Connexion")),
  },
  {
    id: "AG-Didacticiel",
    ref: "AG10",
    title: "Didacticiel agent — première connexion",
    area: "access",
    path: "/creation/a-faire",
    href: "/creation/a-faire?didacticiel=1&etape=1",
    permission: ["creation.followup", "read"],
    persona: "agentNew",
    kind: "window",
    nav: "creation.todo",
    space: "creation",
    note: "Proposé à la première connexion (session.tutorial = « a_voir »).",
    component: lazy(() => import("./boards/AG-Didacticiel")),
  },
  {
    id: "AG-Accueil",
    ref: "AG2",
    title: "Espace agent — à faire aujourd'hui",
    area: "access",
    path: "/creation/a-faire",
    href: "/creation/a-faire",
    permission: ["creation.followup", "read"],
    persona: "agent",
    kind: "page",
    nav: "creation.todo",
    space: "creation",
    component: lazy(() => import("./boards/AG-Accueil")),
  },
  {
    id: "AG-Demandes",
    ref: "AG3",
    title: "Espace agent — demandes de création",
    area: "access",
    path: "/creation/demandes",
    href: "/creation/demandes",
    permission: ["creation", "read"],
    persona: "agent",
    kind: "page",
    nav: "creation.dossiers",
    space: "creation",
    note: "Vue agent des listes de création : réutiliser les composants de liste de l'aire (a).",
    component: lazy(() => import("./boards/AG-Demandes")),
  },
  {
    id: "AG-Fiche",
    ref: "AG4",
    title: "Fiche dossier vue par un agent",
    area: "access",
    path: "/creation/demandes/$dossierId",
    href: "/creation/demandes/dos_atelier_nord",
    permission: ["creation", "read"],
    persona: "agent",
    kind: "drawer",
    nav: "creation.dossiers",
    space: "creation",
    component: lazy(() => import("./boards/AG-Fiche")),
  },
  {
    id: "AG-Lecteur",
    ref: "AG5",
    title: "Espace lecteur — lecture seule",
    area: "access",
    path: "/creation/lecture",
    href: "/creation/lecture",
    permission: ["creation", "read"],
    persona: "lecteur",
    kind: "page",
    nav: "creation.dossiers",
    space: "creation",
    component: lazy(() => import("./boards/AG-Lecteur")),
  },
  {
    id: "AG-Discussions",
    ref: "AG6",
    title: "Discussions — agent et lecteur",
    area: "access",
    path: "/creation/discussions",
    href: "/creation/discussions",
    permission: ["discussions", "read"],
    persona: "agent",
    kind: "page",
    nav: "creation.discussions",
    space: "creation",
    component: lazy(() => import("./boards/AG-Discussions")),
  },
  {
    id: "AG-Rappels",
    ref: "AG7",
    title: "Rappels président et versions des règles",
    area: "access",
    path: "/creation/rappels",
    href: "/creation/rappels",
    permission: ["creation.followup", "read"],
    persona: "agent",
    kind: "page",
    nav: "creation.rappels",
    space: "creation",
    component: lazy(() => import("./boards/AG-Rappels")),
  },
  {
    id: "AG-Equipe",
    ref: "AG8",
    title: "Équipe Melrys — créer un accès agent (admin)",
    area: "access",
    path: "/parametres/equipe",
    href: "/parametres/equipe?fenetre=creer-acces",
    permission: ["team", "read"],
    persona: "admin",
    kind: "window",
    nav: "parametres",
    space: null,
    component: lazy(() => import("./boards/AG-Equipe")),
  },
  {
    id: "AG-Matrice",
    ref: "AG9",
    title: "Référence — ce que chaque rôle peut faire",
    area: "access",
    path: "/reference/roles/matrice",
    href: "/reference/roles/matrice",
    permission: ["reference", "read"],
    persona: "admin",
    kind: "reference",
    nav: "reference",
    space: null,
    component: lazy(() => import("./boards/AG-Matrice")),
  },
  {
    id: "AG-Roles-Reference",
    ref: "—",
    title: "Melrys — Référence des rôles (back-office)",
    area: "access",
    path: "/reference/roles",
    href: "/reference/roles",
    permission: ["reference", "read"],
    persona: "admin",
    kind: "reference",
    nav: "reference",
    space: null,
    component: lazy(() => import("./boards/AG-Roles-Reference")),
  },
  {
    id: "AC-Equipe",
    ref: "AC1",
    title: "Paramètres › Équipe — inviter son comptable (client)",
    area: "access",
    path: "/reference/client/equipe",
    href: "/reference/client/equipe",
    permission: ["reference", "read"],
    persona: "admin",
    kind: "client-app",
    nav: "reference",
    space: null,
    note: "Écran de l'app client (web, Paramètres › Mon équipe) — « plus tard » ; gardé ici en référence.",
    component: lazy(() => import("./boards/AC-Equipe")),
  },
  {
    id: "AC-Achat-Siege",
    ref: "AC7",
    title: "Acheter un siège supplémentaire (client)",
    area: "access",
    path: "/reference/client/siege",
    href: "/reference/client/siege",
    permission: ["reference", "read"],
    persona: "admin",
    kind: "client-app",
    nav: "reference",
    space: null,
    note: "Écran de l'app client (web) — « plus tard ».",
    component: lazy(() => import("./boards/AC-Achat-Siege")),
  },
  {
    id: "AC-Experts",
    ref: "AC2",
    title: "Paramètres › Experts-comptables — rattacher (client)",
    area: "access",
    path: "/reference/client/experts",
    href: "/reference/client/experts",
    permission: ["reference", "read"],
    persona: "admin",
    kind: "client-app",
    nav: "reference",
    space: null,
    note: "Écran de l'app client (web) — « plus tard ».",
    component: lazy(() => import("./boards/AC-Experts")),
  },
  {
    id: "AC-Invitation",
    ref: "AC3",
    title: "Invitation — e-mail, accepter ou refuser",
    area: "access",
    path: "/reference/client/invitation",
    href: "/reference/client/invitation",
    permission: ["reference", "read"],
    persona: "admin",
    kind: "client-app",
    nav: "reference",
    space: null,
    note: "Pages publiques côté client (web /invitation/accepter) — « plus tard ».",
    component: lazy(() => import("./boards/AC-Invitation")),
  },
  {
    id: "AC-Connexion",
    ref: "AC4",
    title: "Connexion expert-comptable et choix de l'entreprise",
    area: "access",
    path: "/cabinet/connexion",
    href: "/cabinet/connexion",
    permission: null,
    persona: null,
    kind: "auth",
    nav: null,
    space: null,
    note: "Variante « Espace cabinet » de la connexion staff (mêmes endpoints).",
    component: lazy(() => import("./boards/AC-Connexion")),
  },
  {
    id: "AC-Didacticiel",
    ref: "AC10",
    title: "Didacticiel expert-comptable — première connexion",
    area: "access",
    path: "/cabinet",
    href: "/cabinet?didacticiel=1",
    permission: ["cabinet.dashboard", "read"],
    persona: "comptable",
    kind: "window",
    nav: "cabinet.cockpit",
    space: "cabinet",
    component: lazy(() => import("./boards/AC-Didacticiel")),
  },
  {
    id: "AC-Cockpit",
    ref: "AC5",
    title: "Espace cabinet vu par l'expert-comptable",
    area: "access",
    path: "/cabinet",
    href: "/cabinet",
    permission: ["cabinet.dashboard", "read"],
    persona: "comptable",
    kind: "page",
    nav: "cabinet.cockpit",
    space: "cabinet",
    component: lazy(() => import("./boards/AC-Cockpit")),
  },
  {
    id: "AC-Revue",
    ref: "AC6",
    title: "Revue comptable — justificatifs et transactions",
    area: "access",
    path: "/cabinet/revue",
    href: "/cabinet/revue",
    permission: ["cabinet.operations", "read"],
    persona: "comptable",
    kind: "page",
    nav: "cabinet.revue",
    space: "cabinet",
    component: lazy(() => import("./boards/AC-Revue")),
  },
  {
    id: "AC-Rattachements",
    ref: "AC7",
    title: "Rattachements expert-comptable (admin)",
    area: "access",
    path: "/compta/rattachements",
    href: "/compta/rattachements",
    permission: ["cabinet.access", "read"],
    persona: "admin",
    kind: "page",
    nav: "compta.clients",
    space: "compta",
    note: "« Plus tard » selon le board.",
    component: lazy(() => import("./boards/AC-Rattachements")),
  },
  {
    id: "AC-Affectation",
    ref: "AC8",
    title: "Affectation de l'expert principal (admin)",
    area: "access",
    path: "/compta/affectation",
    href: "/compta/affectation",
    permission: ["cabinet.access", "read"],
    persona: "admin",
    kind: "page",
    nav: "compta.clients",
    space: "compta",
    note: "« Plus tard » selon le board.",
    component: lazy(() => import("./boards/AC-Affectation")),
  },
  {
    id: "AC-Matrice",
    ref: "AC9",
    title: "Référence — périmètre de l'expert-comptable",
    area: "access",
    path: "/reference/cabinet/matrice",
    href: "/reference/cabinet/matrice",
    permission: ["reference", "read"],
    persona: "admin",
    kind: "reference",
    nav: "reference",
    space: null,
    component: lazy(() => import("./boards/AC-Matrice")),
  },
];
